import type React from 'react';
import { PAYMENT_SCOPE, useShortcutScope } from '@/components/shortcuts';

/**
 * Pushed only while the payment dialog is open, suspending the rest of the
 * `seller` scope so no sale-screen shortcut fires underneath it — mirrors
 * `VoidConfirmScope` in `cartPanel/`. A named sibling of `PaymentModal.tsx`
 * rather than a second component in that file (rulebook §5.2).
 */
export const PaymentScope: React.FC = () => {
    useShortcutScope(PAYMENT_SCOPE);
    return null;
};
